import React from 'react'

const MarchOut = () => {
  return (
    <div>MarchOut</div>
  )
}

export default MarchOut